import VBadge from './VBadge'

/* istanbul ignore next */
VBadge.install = function install (Vue) {
  Vue.component(VBadge.name, VBadge)
}

export default VBadge



// WEBPACK FOOTER //
// ./src/components/VBadge/index.js